// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'spelling-dictionary-index',
    standalone: false,
    template: `
        <page-header
                [icon]="['QA', 'DICTIONARY'] | monIcons"
                [header]="'Account dictionary' | translate"
                [subHeader]="subheaderTranslation">
        </page-header>
        <mon-tabs
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatus($event)"
                (onSearch)="onSearch($event)"
                [search]="search"
                [minSearchLength]="1"
                [maxOptionsDisplay]="6"
                [showSearch]="true">
                <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="px-4">
                    <table-container
                            [collection]="words"
                            [noResultMessage]="'No words have been added to the default dictionary' | translate"
                            (onPageChange)="onPageChange($event)"
                            (onPerPageChange)="onPageSizeChange($event)"
                            class="table-vertial-align"
                            [progress]="promise">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="col-sm-20 col-md-20 col-lg-20" translate>Word</th>
                                    <th class="text-right col-sm-5 col-md-5 col-lg-4" translate>Language</th>
                                    <th class="text-right" translate>Added date</th>
                                    <th class="text-right" translate>Added by</th>
                                    <th class="text-right col-sm-5 col-md-5 col-lg-8" translate>Remove from dictionary</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let word of words; trackBy: trackByWordId">
                                    <td class="text-v-middle">{{ word.word }}</td>
                                    <td class="text-right text-v-middle"> <language [language]="word.language"></language></td>
                                    <td class="text-right text-v-middle"><user-date [date]="word.created_at"></user-date></td>
                                    <td class="text-right text-v-middle">
                                        {{ word.added_by?.first_name }} {{ word.added_by?.last_name }}
                                    </td>
                                    <td class="text-right text-v-middle">
                                        <span
                                                role="button"
                                                [attr.aria-label]="'Remove this word from dictionary' | translate"
                                                class="btn btn-border-radius btn-link"
                                                ngbTooltip="{{ 'Remove word from dictionary' | translate }}"
                                                [triggers]="'focus hover'"
                                                [placement]="'bottom'"
                                                monModalConfirm="{{ 'Are you sure you want to remove the word <strong>[[word]]</strong> from the dictionary? <br />Please note, the misspelling will first show up after a new scan' | translate:'':{word: word.word} }}"
                                                (monModalConfirmAction)="removeWord(word)"
                                                monEventTrigger="actionTrigger"
                                                [monEventParams]="{action:'spellcheck-remove-from-dictionary'}"
                                        >
                                            Remove from dictionary
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class SpellingDictionaryIndexComponent extends BaseContainerComponentController implements OnInit {
    type: any = null;
    domainId: any;
    words: any = [];
    tabs: any = [];
    subheaderTranslation: string = '';
    exports: any = [];
    promise: any;

    constructor (
        private translateService: TranslateService,
        private stateService: StateService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.type = null;
        this.domainId = Number(this.stateService.params.domainId);
        this.words = [];
        this.tabs = [{ name: this.translateService.getString('All'), faIcon: 'fas fa-language', value: 'all' }];
        this.activeTab = this.tabs[0].value;
        this.subheaderTranslation = '';
        this.exports = [
            {
                name: this.translateService.getString('Dictionary'),
                data: {
                    category: 'account_dictionary',
                },
            },
        ];

        this.spellingRepoService.getAllLanguages({ domain_id: this.stateService.params.domainId }).then((data: any) => {
            data.forEach((item: any) => {
                this.tabs.push({
                    name: this.pipeService.get('translateLanguage')(item.lang),
                    faIcon: 'fas fa-language',
                    value: item.lang,
                });
            });
        });

        this.getPage();
    }

    override getPage = () => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            language: this.activeTab === 'all' ? null : this.activeTab,
            search: this.search,
            type: this.type || 'dictionary',
            domainId: this.domainId,
            domain_id: this.domainId,
        };
        this.promise = this.spellingRepoService.getAllWords(params).then((data: any) => {
            this.words = data;
            this.getSubHeaderDescription();
        });
    };

    private getSubHeaderDescription () {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')(this.words.total, '0,0'),
            '1 word added across all domains',
            '[[count]] words added across all domains',
            { count: this.pipeService.get('monNumber')(this.words.total, '0,0') },
            this.words.total,
        );
    }

    removeWord (word: any) {
        this.spellingRepoService.destroyWord(word.id).then(() => {
            this.getPage();
        });
    }

    trackByWordId (index: number, word: any): any {
        return word.id;
    }
}
